import Vue from 'vue';
import store from '@/store';
import http from './http.service';
import i18n from '@/i18n';
import api from './data.services';
import router from '@/router';

async function loginDirect(credentials) {
  try {
    const response = await http.post('/login', credentials);
    return Promise.resolve(response);
  } catch (err) {
    err = {
      mensagem:
        err != null && err.message !== undefined
          ? err.message
          : i18n.t('Houve um problema ao conectar ao servidor. Tente novamente.')
    };
    return Promise.reject(err);
  }
}

function integratedLogin(authData) {
  store.dispatch('auth/registerLogin', authData);
  return http
    .post('/api/common/session/addon', authData)
    .then((data) => {
      store.dispatch('user/registerUserSessionData', { data });
      return true;
    })
    .catch((err) => {
      err = {
        mensagem:
          err != null && err.message !== undefined
            ? err.message
            : i18n.t('Houve um problema ao conectar ao servidor. Tente novamente.')
      };
      store.dispatch('auth/registerAuthFailure', err);
      logout();
      return false;
    });
}

function changePassword(credentials) {
  //TODO
}

function logout() {
  api.save('logout', {}, null, true).then((res) => {
    store.dispatch('auth/logout');
    store.dispatch('user/logout');
    router.push('/');
  });
  return Promise.resolve();
}

const auth = {
  loginDirect,
  integratedLogin,
  changePassword,
  logout
};

Vue.prototype.$auth = auth;

export default auth;
